import styled from 'styled-components';
import { motion } from 'framer-motion';

export const DateInput = styled.input`
  width: 100%;
  font-size: 14pt;
  padding-left: 5px;
  border-radius: 4px;
  border: 1px solid darkgrey;
`;

export const Input = styled(motion.input)`
  border-radius: 5px;
  font-size: 15px;
  font-family: 'EffraRegular';
`;
